import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../services/useApiHelper";

export default function useSocialSchedules(agencyId) {
  const staleTime = 1000 * 60;
  const queryClient = useQueryClient();
  const { get, post, put, del } = useApiHelper();

  const socialSchedules = useQuery(
    ["socialSchedules", agencyId],
    () => get(`/socialSchedule/${agencyId}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  const add = useMutation(
    (newSchedule) => post(`/socialSchedule`, newSchedule),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["socialSchedules"])
      },
    }
  );

  const update = useMutation(
    (schedule) => put(`/socialSchedule/${schedule.id}`, schedule),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["socialSchedules"])
      },
    }
  );

  const remove = useMutation(
    (scheduleId) => del(`/socialSchedule/${scheduleId}`),
    {
      onSuccess: (_, scheduleId) => {
        queryClient.invalidateQueries(["socialSchedules"])
      },
    }
  );

  const addEmptyPost = useMutation(
    (scheduleId) => put(`/socialSchedule/${scheduleId}/emptypostdata`, null),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["socialSchedules"])
      },
    }
  );

  return {
    socialSchedules,
    add,
    update,
    remove,
    addEmptyPost
  };
}
